import * as React from 'react'

import { EuiBasicTable } from '@equipmentshare/ds2'

export type TableProps = {
  columns: any[],
  emptyStateText: string,
  rows: any[] | null | undefined,
  isLoading: boolean,
};

export default function Table( { columns, emptyStateText, rows, isLoading }: TableProps ): React.ReactElement {
	return (
		<EuiBasicTable
			columns={columns}
			noItemsMessage={emptyStateText}
			items={rows ?? []}
			hasActions
			loading={isLoading}
			tableLayout="auto"
		/>
	)
}
